import { observer } from 'mobx-react';
import React from 'react';
import shipstationSvg from 'themes/img/shipstation.svg';

// Leading badge for a rate-dropdown row. LTL freight rates and carrier-less ShipStation rates
// each get a marker so they stand out from regular carrier-account rates.
const RateBadge = ({ data: { extra } }) => {
	if (!extra) return null;
	if (extra.isLtl) return <i className="icon icon--med icon--ltl spc--right--tny" />;
	if (extra.isShipStation)
		return (
			<img
				src={shipstationSvg}
				alt="ShipStation"
				title="ShipStation"
				width={16}
				height={16}
				className="spc--right--tny"
				style={{ verticalAlign: 'middle' }}
			/>
		);
	return null;
};

export default observer(RateBadge);
